import palette from "./palette"

export default {
  darkGreen: {
    surface: {
      inside: palette.green['300'],
      outside: palette.green['50'],
      line: palette.green['50'],
      text: {
        base: {
          primary: palette.grayscale['50'],
          negative: palette.grayscale['900'],
          error: palette.red['50']
        },
        accent: {
          base: palette.green['100']
        },
        highlight: {
          background: palette.green['100'],
          text: palette.green['300']
        }
      },
      tags: {
        background: palette.green['50'],
        text: palette.grayscale['900']
      }
    },
    button: {
      primary: {
        bgDefault: palette.green['200'],
        bgHover: palette.green['100'],
        bgPressed: palette.grayscale['50'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.grayscale['50'],
        textHover: palette.green['300'],
        textPressed: palette.green['300'],
        textDisabled: palette.grayscale['100'],
        iconDefault: palette.grayscale['50'],
        iconHover: palette.green['300'],
        iconPressed: palette.green['300'],
        iconDisabled: palette.grayscale['100'],
        borderDefault: palette.green['200'],
        borderHover: palette.green['100'],
        borderDisabled: palette.grayscale['200'],
      },
      secondary: {
        bgDefault: palette.grayscale['50'],
        bgHover: palette.greenHill['100'],
        bgPressed: palette.green['100'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.green['300'],
        textHover: palette.green['0'],
        textPressed: palette.green['300'],
        textDisabled: palette.grayscale['100'],
        iconDefault: palette.green['300'],
        iconHover: palette.green['0'],
        iconPressed: palette.green['300'],
        iconDisabled: palette.grayscale['100'],
        borderDefault: palette.grayscale['50'],
        borderHover: palette.grayscale['50'],
        borderDisabled: palette.grayscale['200'],
      },
      tertiary: {
        bgDefault: palette.green['300'],
        bgHover: palette.grayscale['50'],
        bgPressed: palette.green['100'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.grayscale['50'],
        textHover: palette.green['300'],
        textDisabled: palette.grayscale['300'],
        iconDefault: palette.grayscale['50'],
        iconHover: palette.green['300'],
        iconDisabled: palette.grayscale['300'],
        borderDefault: palette.grayscale['50'],
        borderHover: palette.grayscale['50'],
        borderDisabled: palette.grayscale['200'],
      }
    },
    faq: {
      border: 'rgba(255, 255, 255, 0.5)'
    },
    tabs: {
      selected: {
        bgDefault: palette.green['300'],
        bgHover: palette.greenHill['700'],
        bgPressed: palette.green['300'],
        textDefault: palette.grayscale['50'],
        textHover: palette.grayscale['50'],
        textPressed: palette.grayscale['50'],
        borderDefault: palette.green['300'],
        borderHover: palette.greenHill['700'],
        borderPressed: palette.green['300'],
      },
      unselected: {
        bgDefault: palette.grayscale['50'],
        bgHover: palette.greenHill['100'],
        bgPressed: palette.grayscale['50'],
        textDefault: palette.green['300'],
        textHover: palette.green['300'],
        textPressed: palette.green['300'],
        borderDefault: palette.green['300'],
        borderHover: palette.grayscale['50'],
        borderPressed: palette.green['300'],
      }
    },
    imageComparison: {
      sliderHandle: palette.green['300'],
      sliderHandleIcon: palette.grayscale['50']
    },
    resourceHub: {
      pagination: {
        bgDefault: palette.grayscale['100'],
        textDefault: palette.green['300'],
        borderDefault: palette.grayscale['100'],
        bgHover: 'transparent',
        textHover: palette.green['300'],
        borderHover: palette.green['300'],
        bgActive: palette.green['300'],
        textActive: palette.grayscale['100'],
        bgDisabled: palette.grayscale['200'],
        textDisabled: palette.grayscale['400'],
      }
    },
    icon: {
      base: {
        primary: palette.grayscale['900'],
        secondary: palette.grayscale['50'],
        tertiary: palette.grayscale['500'],
        inactive: palette.grayscale['400'],
      }
    },
    stepper: {
      progressBar: {
        active: palette.greenHill['400'],
        completed: palette.green['300'],
        pending: palette.grayscale['100'],
      },
      stepLabel: palette.green['300'],
      stepIcon: palette.green['100'],
    }
  },
  green: {
    surface: {
      inside: palette.green['0'],
      outside: palette.green['50'],
      line: palette.green['50'],
      text: {
        base: {
          primary: palette.grayscale['900'],
          negative: palette.grayscale['900'],
          error: palette.red['50']
        },
        accent: {
          base: palette.green['200']
        },
        highlight: {
          background: palette.green['300'],
          text: palette.green['0']
        }
      },
      tags: {
        background: palette.green['50'],
        text: palette.grayscale['900']
      }
    },
    button: {
      primary: {
        bgDefault: palette.green['200'],
        bgHover: palette.green['300'],
        bgPressed: palette.green['300'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.grayscale['50'],
        textHover: palette.grayscale['50'],
        textPressed: palette.grayscale['50'],
        textDisabled: palette.grayscale['100'],
        iconDefault: palette.grayscale['50'],
        iconHover: palette.grayscale['50'],
        iconPressed: palette.grayscale['50'],
        iconDisabled: palette.grayscale['100'],
        borderDefault: palette.greenHill['100'],
        borderHover: palette.green['300'],
        borderDisabled: palette.grayscale['100'],
      },
      secondary: {
        bgDefault: palette.greenHill['100'],
        bgHover: palette.green['300'],
        bgPressed: palette.green['100'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.green['300'],
        textHover: palette.grayscale['50'],
        textPressed: palette.green['300'],
        textDisabled: palette.grayscale['300'],
        iconDefault: palette.green['300'],
        iconHover: palette.grayscale['50'],
        iconPressed: palette.green['300'],
        iconDisabled: palette.grayscale['300'],
        borderDefault: palette.green['300'],
        borderHover: palette.green['300'],
        borderDisabled: palette.grayscale['200'],
      },
      tertiary: {
        bgDefault: palette.green['200'],
        bgHover: palette.green['300'],
        bgPressed: palette.green['100'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.grayscale['50'],
        textHover: palette.grayscale['50'],
        textDisabled: palette.grayscale['300'],
        iconDefault: palette.grayscale['50'],
        iconHover: palette.grayscale['50'],
        iconDisabled: palette.grayscale['300'],
        borderDefault: palette.green['200'],
        borderHover: palette.green['300'],
        borderDisabled: palette.grayscale['200'],
      }
    },
    faq: {
      border: 'rgba(0, 0, 0, 0.5)'
    },
    tabs: {
      selected: {
        bgDefault: palette.green['0'],
        bgHover: palette.greenHill['50'],
        bgPressed: palette.green['0'],
        textDefault: palette.green['300'],
        textHover: palette.green['300'],
        textPressed: palette.green['300'],
        borderDefault: palette.green['0'],
        borderHover: palette.greenHill['50'],
        borderPressed: palette.green['0'],
      },
      unselected: {
        bgDefault: palette.grayscale['50'],
        bgHover: palette.greenHill['100'],
        bgPressed: palette.grayscale['50'],
        textDefault: palette.green['300'],
        textHover: palette.green['300'],
        textPressed: palette.green['300'],
        borderDefault: palette.greenHill['100'],
        borderHover: palette.grayscale['50'],
        borderPressed: palette.green['300'],
      }
    },
    imageComparison: {
      sliderHandle: palette.green['100'],
      sliderHandleIcon: palette.grayscale['900']
    },
    resourceHub: {
      pagination: {
        bgDefault: palette.grayscale['100'],
        textDefault: palette.green['300'],
        borderDefault: palette.grayscale['100'],
        bgHover: 'transparent',
        textHover: palette.green['300'],
        borderHover: palette.green['300'],
        bgActive: palette.green['300'],
        textActive: palette.grayscale['100'],
        bgDisabled: palette.grayscale['200'],
        textDisabled: palette.grayscale['400'],
      }
    },
    icon: {
      base: {
        primary: palette.grayscale['900'],
        secondary: palette.grayscale['50'],
        tertiary: palette.grayscale['500'],
        inactive: palette.grayscale['400'],
      }
    },
    stepper: {
      progressBar: {
        active: palette.greenHill['400'],
        completed: palette.green['300'],
        pending: palette.grayscale['100'],
      },
      stepLabel: palette.green['300'],
      stepIcon: palette.green['100'],
    }
  },
  lightGreen: {
    surface: {
      inside: palette.green['50'],
      outside: palette.green['300'],
      line: palette.green['300'],
      text: {
        base: {
          primary: palette.grayscale['900'],
          negative: palette.grayscale['50'],
          error: palette.red['50']
        },
        accent: {
          base: palette.green['200']
        },
        highlight: {
          background: palette.green['300'],
          text: palette.green['100']
        }
      },
      tags: {
        background: palette.green['0'],
        text: palette.grayscale['900']
      }
    },
    button: {
      primary: {
        bgDefault: palette.green['200'],
        bgHover: palette.greenHill['100'],
        bgPressed: palette.grayscale['50'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.grayscale['50'],
        textHover: palette.grayscale['900'],
        textPressed: palette.green['300'],
        textDisabled: palette.grayscale['100'],
        iconDefault: palette.grayscale['50'],
        iconHover: palette.grayscale['900'],
        iconPressed: palette.green['300'],
        iconDisabled: palette.grayscale['100'],
        borderDefault: palette.green['200'],
        borderHover: palette.greenHill['100'],
        borderDisabled: palette.grayscale['100'],
      },
      secondary: {
        bgDefault: palette.green['100'],
        bgHover: palette.grayscale['50'],
        bgPressed: palette.green['100'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.green['300'],
        textHover: palette.green['300'],
        textPressed: palette.green['300'],
        textDisabled: palette.grayscale['500'],
        iconDefault: palette.green['300'],
        iconHover: palette.green['300'],
        iconPressed: palette.green['300'],
        iconDisabled: palette.grayscale['500'],
        borderDefault: palette.green['50'],
        borderHover: palette.green['50'],
        borderDisabled: palette.grayscale['500'],
      },
      tertiary: {
        bgDefault: palette.green['50'],
        bgHover: palette.green['300'],
        bgPressed: palette.green['100'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.green['300'],
        textHover: palette.green['50'],
        textDisabled: palette.grayscale['300'],
        iconDefault: palette.green['300'],
        iconHover: palette.green['50'],
        iconDisabled: palette.grayscale['300'],
        borderDefault: palette.green['300'],
        borderHover: palette.green['300'],
        borderDisabled: palette.grayscale['200'],
      }
    },
    faq: {
      border: 'rgba(0, 0, 0, 0.5)'
    },
    tabs: {
      selected: {
        bgDefault: palette.green['50'],
        bgHover: palette.greenHill['50'],
        bgPressed: palette.green['50'],
        textDefault: palette.green['300'],
        textHover: palette.green['300'],
        textPressed: palette.green['300'],
        borderDefault: palette.green['50'],
        borderHover: palette.greenHill['50'],
        borderPressed: palette.green['50'],
      },
      unselected: {
        bgDefault: palette.grayscale['50'],
        bgHover: palette.greenHill['700'],
        bgPressed: palette.greenHill['700'],
        textDefault: palette.grayscale['400'],
        textHover: palette.grayscale['50'],
        textPressed: palette.grayscale['400'],
        borderDefault: palette.grayscale['400'],
        borderHover: palette.grayscale['50'],
        borderPressed: palette.greenHill['500'],
      }
    },
    imageComparison: {
      sliderHandle: palette.greenHill['50'],
      sliderHandleIcon: palette.grayscale['900']
    },
    resourceHub: {
      pagination: {
        bgDefault: palette.grayscale['100'],
        textDefault: palette.green['300'],
        borderDefault: palette.grayscale['100'],
        bgHover: 'transparent',
        textHover: palette.green['300'],
        borderHover: palette.green['300'],
        bgActive: palette.green['300'],
        textActive: palette.grayscale['100'],
        bgDisabled: palette.grayscale['200'],
        textDisabled: palette.grayscale['400'],
      }
    },
    icon: {
      base: {
        primary: palette.grayscale['900'],
        secondary: palette.grayscale['50'],
        tertiary: palette.grayscale['500'],
        inactive: palette.grayscale['400'],
      }
    },
    stepper: {
      progressBar: {
        active: palette.greenHill['400'],
        completed: palette.green['300'],
        pending: palette.grayscale['100'],
      },
      stepLabel: palette.green['300'],
      stepIcon: palette.green['100'],
    }
  },
  darkBlue: {
    surface: {
      inside: palette.blue['700'],
      outside: palette.blue['200'],
      line: palette.blue['200'],
      text: {
        base: {
          primary: palette.grayscale['50'],
          negative: palette.grayscale['900'],
          error: palette.red['50']
        },
        accent: {
          base: palette.blue['200']
        },
        highlight: {
          background: palette.blue['200'],
          text: palette.blue['700']
        }
      },
      tags: {
        background: palette.blue['200'],
        text: palette.grayscale['900']
      }
    },
    button: {
      primary: {
        bgDefault: palette.grayscale['50'],
        bgHover: palette.blue['300'],
        bgPressed: palette.grayscale['50'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.blue['700'],
        textHover: palette.blue['700'],
        textPressed: palette.blue['700'],
        textDisabled: palette.grayscale['300'],
        iconDefault: palette.blue['700'],
        iconHover: palette.blue['700'],
        iconPressed: palette.blue['700'],
        iconDisabled: palette.grayscale['300'],
        borderDefault: palette.grayscale['50'],
        borderHover: palette.blue['300'],
        borderDisabled: palette.grayscale['200'],
      },
      secondary: {
        bgDefault: palette.blue['100'],
        bgHover: palette.blue['700'],
        bgPressed: palette.grayscale['50'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.blue['700'],
        textHover: palette.grayscale['50'],
        textPressed: palette.blue['700'],
        textDisabled: palette.grayscale['300'],
        iconDefault: palette.blue['700'],
        iconHover: palette.grayscale['50'],
        iconPressed: palette.blue['700'],
        iconDisabled: palette.grayscale['300'],
        borderDefault: palette.grayscale['50'],
        borderHover: palette.blue['700'],
        borderDisabled: palette.grayscale['200'],
      },
      tertiary: {
        bgDefault: palette.blue['100'],
        bgHover: palette.blue['700'],
        bgPressed: palette.blue['200'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.grayscale['50'],
        textHover: palette.blue['700'],
        textDisabled: palette.grayscale['300'],
        iconDefault: palette.grayscale['50'],
        iconHover: palette.blue['700'],
        iconDisabled: palette.grayscale['300'],
        borderDefault: palette.grayscale['50'],
        borderHover: palette.grayscale['50'],
        borderDisabled: palette.grayscale['200'],
      }
    },
    faq: {
      border: 'rgba(255, 255, 255, 0.5)'
    },
    tabs: {
      selected: {
        bgDefault: palette.blue['700'],
        bgHover: palette.grayscale['50'],
        bgPressed: palette.blue['800'],
        textDefault: palette.grayscale['50'],
        textHover: palette.blue['700'],
        textPressed: palette.grayscale['50'],
        borderDefault: palette.blue['700'],
        borderHover: palette.blue['700'],
        borderPressed: palette.blue['700'],
      },
      unselected: {
        bgDefault: 'transparent',
        bgHover: palette.blue['500'],
        bgPressed: palette.blue['600'],
        textDefault: palette.blue['700'],
        textHover: palette.grayscale['50'],
        textPressed: palette.grayscale['50'],
        borderDefault: palette.blue['700'],
        borderHover: palette.grayscale['50'],
        borderPressed: palette.grayscale['50'],
      }
    },
    imageComparison: {
      sliderHandle: palette.blue['800'],
      sliderHandleIcon: palette.grayscale['50']
    },
    resourceHub: {
      pagination: {
        bgDefault: palette.grayscale['100'],
        textDefault: palette.green['300'],
        borderDefault: palette.grayscale['100'],
        bgHover: 'transparent',
        textHover: palette.green['300'],
        borderHover: palette.green['300'],
        bgActive: palette.green['300'],
        textActive: palette.grayscale['100'],
        bgDisabled: palette.grayscale['200'],
        textDisabled: palette.grayscale['400'],
      }
    },
    icon: {
      base: {
        primary: palette.grayscale['900'],
        secondary: palette.grayscale['50'],
        tertiary: palette.grayscale['500'],
        inactive: palette.grayscale['400'],
      }
    },
    stepper: {
      progressBar: {
        active: palette.greenHill['400'],
        completed: palette.green['300'],
        pending: palette.grayscale['100'],
      },
      stepLabel: palette.green['300'],
      stepIcon: palette.green['100'],
    }
  },
  lightBlue: {
    surface: {
      inside: palette.blue['200'],
      outside: palette.blue['700'],
      line: palette.blue['700'],
      text: {
        base: {
          primary: palette.grayscale['900'],
          negative: palette.grayscale['50']
        },
        accent: {
          base: palette.blue['700']
        },
        highlight: {
          background: palette.blue['700'],
          text: palette.blue['200']
        }
      },
      tags: {
        background: palette.blue['700'],
        text: palette.grayscale['50']
      }
    },
    button: {
      primary: {
        bgDefault: palette.blue['500'],
        bgHover: palette.grayscale['50'],
        bgPressed: palette.blue['500'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.grayscale['50'],
        textHover: palette.blue['700'],
        textPressed: palette.grayscale['50'],
        textDisabled: palette.grayscale['300'],
        iconDefault: palette.grayscale['50'],
        iconHover: palette.blue['700'],
        iconPressed: palette.grayscale['50'],
        iconDisabled: palette.grayscale['300'],
        borderDefault: palette.blue['500'],
        borderHover: palette.grayscale['50'],
        borderDisabled: palette.grayscale['200'], 
      },
      secondary: {
        bgDefault: palette.blue['200'],
        bgHover: palette.blue['500'],
        bgPressed: palette.grayscale['50'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.blue['700'],
        textHover: palette.grayscale['50'],
        textPressed: palette.blue['700'],
        textDisabled: palette.grayscale['300'],
        iconDefault: palette.blue['700'],
        iconHover: palette.grayscale['50'],
        iconPressed: palette.blue['700'],
        iconDisabled: palette.grayscale['300'],
        borderDefault: palette.blue['700'],
        borderHover: palette.blue['500'],
        borderDisabled: palette.grayscale['200']
      },
      tertiary: {
        bgDefault: palette.grayscale['50'],
        bgHover: palette.blue['700'],
        bgPressed: palette.grayscale['50'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.blue['700'],
        textHover: palette.grayscale['50'],
        textDisabled: palette.grayscale['300'],
        iconDefault: palette.blue['700'],
        iconHover: palette.grayscale['50'],
        iconDisabled: palette.grayscale['300'],
        borderDefault: palette.grayscale['50'],
        borderHover: palette.grayscale['50'],
        borderDisabled: palette.grayscale['200']
      }
    },
    faq: {
      border: 'rgba(0, 0, 0, 0.5)'
    },
    tabs: {
      selected: {
        bgDefault: palette.blue['200'],
        bgHover: palette.grayscale['50'],
        bgPressed: palette.blue['800'],
        textDefault: palette.blue['800'],
        textHover: palette.blue['700'],
        textPressed: palette.grayscale['50'],
        borderDefault: palette.blue['200'],
        borderHover: palette.blue['200'],
        borderPressed: palette.blue['200'],
      },
      unselected: {
        bgDefault: 'transparent',
        bgHover: palette.blue['600'],
        bgPressed: palette.blue['800'],
        textDefault: palette.blue['200'],
        textHover: palette.grayscale['50'],
        textPressed: palette.grayscale['50'],
        borderDefault: palette.blue['200'],
        borderHover: palette.grayscale['50'],
        borderPressed: palette.blue['200'],
      }
    },
    imageComparison: {
      sliderHandle: palette.blue['100'],
      sliderHandleIcon: palette.grayscale['900']
    },
    resourceHub: {
      pagination: {
        bgDefault: palette.grayscale['100'],
        textDefault: palette.green['300'],
        borderDefault: palette.grayscale['100'],
        bgHover: 'transparent',
        textHover: palette.green['300'],
        borderHover: palette.green['300'],
        bgActive: palette.green['300'],
        textActive: palette.grayscale['100'],
        bgDisabled: palette.grayscale['200'],
        textDisabled: palette.grayscale['400'],
      }
    },
    icon: {
      base: {
        primary: palette.grayscale['900'],
        secondary: palette.grayscale['50'],
        tertiary: palette.grayscale['500'],
        inactive: palette.grayscale['400'],
      }
    },
    stepper: {
      progressBar: {
        active: palette.greenHill['400'],
        completed: palette.green['300'],
        pending: palette.grayscale['100'],
      },
      stepLabel: palette.green['300'],
      stepIcon: palette.green['100'],
    }
  },
  yellowGreen: {
    surface: {
      inside: palette.yellowGreen['200'],
      outside: palette.yellowGreen['600'],
      line: palette.grayscale['900'],
      text: {
        base: {
          primary: palette.grayscale['900'],
          negative: palette.grayscale['900'],
          error: palette.red['50']
        },
        accent: {
          base: palette.grayscale['900']
        },
        highlight: {
          background: palette.grayscale['900'],
          text: palette.grayscale['50']
        }
      },
      tags: {
        background: palette.yellowGreen['600'],
        text: palette.grayscale['900']
      }
    },
    button: {
      primary: {
        bgDefault: palette.grayscale['900'],
        bgHover: palette.yellowGreen['600'],
        bgPressed: palette.grayscale['900'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.yellowGreen['600'],
        textHover: palette.grayscale['900'],
        textPressed: palette.yellowGreen['600'],
        textDisabled: palette.grayscale['300'],
        iconDefault: palette.yellowGreen['600'],
        iconHover: palette.grayscale['900'],
        iconPressed: palette.yellowGreen['600'],
        iconDisabled: palette.grayscale['300'],
        borderDefault: palette.grayscale['900'],
        borderHover: palette.grayscale['900'],
        borderDisabled: palette.grayscale['200']
      },
      secondary: {
        bgDefault: palette.yellowGreen['600'],
        bgHover: palette.grayscale['900'],
        bgPressed: palette.yellowGreen['600'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.grayscale['900'],
        textHover: palette.yellowGreen['600'],
        textPressed: palette.grayscale['900'],
        textDisabled: palette.grayscale['300'],
        iconDefault: palette.grayscale['900'],
        iconHover: palette.yellowGreen['600'],
        iconPressed: palette.grayscale['900'],
        iconDisabled: palette.grayscale['300'],
        borderDefault: palette.grayscale['900'],
        borderHover: palette.yellowGreen['600'],
        borderDisabled: palette.grayscale['200']
      },
      tertiary: {
        bgDefault: palette.yellowGreen['600'],
        bgHover: palette.grayscale['900'],
        bgPressed: palette.yellowGreen['600'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.grayscale['800'],
        textHover: palette.yellowGreen['600'],
        textDisabled: palette.grayscale['300'],
        iconDefault: palette.grayscale['900'],
        iconHover: palette.yellowGreen['600'],
        iconDisabled: palette.grayscale['300'],
        borderDefault: palette.yellowGreen['600'],
        borderHover: palette.grayscale['800'],
        borderDisabled: palette.grayscale['200']
      },
    },
    faq: {
      border: 'rgba(0, 0, 0, 0.5)'
    },
    tabs: {
      selected: {
        bgDefault: palette.yellowGreen['200'],
        bgHover: palette.yellowGreen['200'],
        bgPressed: palette.yellowGreen['200'],
        textDefault: palette.grayscale['900'],
        textHover: palette.grayscale['900'],
        textPressed: palette.grayscale['900'],
        borderDefault: palette.yellowGreen['200'],
        borderHover: palette.yellowGreen['200'],
        borderPressed: palette.grayscale['900'],
      },
      unselected: {
        bgDefault: palette.grayscale['50'],
        bgHover: palette.yellowGreen['400'],
        bgPressed: palette.yellowGreen['200'],
        textDefault: palette.grayscale['900'],
        textHover: palette.grayscale['900'],
        textPressed: palette.grayscale['900'],
        borderDefault: palette.yellowGreen['200'],
        borderHover: palette.yellowGreen['400'],
        borderPressed: palette.grayscale['900'],
      }
    },
    imageComparison: {
      sliderHandle: palette.yellowGreen['600'],
      sliderHandleIcon: palette.grayscale['900']
    },
    resourceHub: {
      pagination: {
        bgDefault: palette.grayscale['100'],
        textDefault: palette.green['300'],
        borderDefault: palette.grayscale['100'],
        bgHover: 'transparent',
        textHover: palette.green['300'],
        borderHover: palette.green['300'],
        bgActive: palette.green['300'],
        textActive: palette.grayscale['100'],
        bgDisabled: palette.grayscale['200'],
        textDisabled: palette.grayscale['400'],
      }
    },
    icon: {
      base: {
        primary: palette.grayscale['900'],
        secondary: palette.grayscale['50'],
        tertiary: palette.grayscale['500'],
        inactive: palette.grayscale['400'],
      }
    },
    stepper: {
      progressBar: {
        active: palette.greenHill['400'],
        completed: palette.green['300'],
        pending: palette.grayscale['100'],
      },
      stepLabel: palette.green['300'],
      stepIcon: palette.green['100'],
    }
  },
  footer: {
    surface: {
      inside: palette.green['300'],
      outside: palette.green['300'],
      line: palette.green['50'],
      text: {
        base: {
          primary: palette.grayscale['50'],
          negative: palette.grayscale['900']
        },
        accent: {
          base: palette.green['100']
        },
        highlight: {
          background: palette.green['100'],
          text: palette.green['300']
        }
      }
    },
    button: {
      primary: {
        bgDefault: palette.green['50'],
        bgHover: palette.green['100'],
        bgPressed: palette.grayscale['50'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.green['300'],
        textHover: palette.grayscale['50'],
        textDisabled: palette.grayscale['300'],
        iconDefault: palette.green['300'],
        iconHover: palette.green['300'],
        iconDisabled: palette.grayscale['300'],
        borderDefault: palette.green['50'],
        borderHover: palette.green['100'],
        borderDisabled: palette.grayscale['200']
      },
      secondary: {
        bgDefault: palette.grayscale['50'],
        bgHover: palette.green['50'],
        bgPressed: palette.green['100'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.green['300'],
        textHover: palette.grayscale['50'],
        textDisabled: palette.grayscale['300'],
        iconDefault: palette.green['300'],
        iconHover: palette.grayscale['50'],
        iconDisabled: palette.grayscale['300'],
        borderDefault: palette.grayscale['50'],
        borderHover: palette.green['50'],
        borderDisabled: palette.grayscale['200']
      },
      tertiary: {
        bgDefault: palette.green['300'],
        bgHover: palette.grayscale['50'],
        bgPressed: palette.green['100'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.grayscale['50'],
        textHover: palette.green['300'],
        textDisabled: palette.grayscale['300'],
        iconDefault: palette.grayscale['50'],
        iconHover: palette.green['300'],
        iconDisabled: palette.grayscale['300'],
        borderDefault: palette.grayscale['50'],
        borderHover: palette.grayscale['50'],
        borderDisabled: palette.grayscale['200']
      }
    },
    faq: {
      border: 'rgba(255, 255, 255, 0.5)'
    }
  },
  header: {
    surface: {
      inside: palette.grayscale['50'],
      outside: palette.grayscale['50'],
      line: palette.green['200'],
      text: {
        base: {
          primary: palette.grayscale['900'],
          negative: palette.grayscale['50'],
          error: palette.red['50']
        },
        accent: {
          base: palette.green['200']
        },
        highlight: {
          background: palette.green['200'],
          text: palette.grayscale['50']
        }
      }
    },
    button: {
      primary: {
        bgDefault: palette.green['200'],
        bgHover: palette.green['0'],
        bgPressed: palette.green['200'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.grayscale['50'],
        textHover: palette.green['200'],
        textDisabled: palette.grayscale['300'],
        iconDefault: palette.grayscale['50'],
        iconHover: palette.green['200'],
        iconDisabled: palette.grayscale['300'],
        borderDefault: palette.green['200'],
        borderHover: palette.green['200'],
        borderDisabled: palette.grayscale['200'],
      },
      secondary: {
        bgDefault: palette.grayscale['50'],
        bgHover: palette.green['50'],
        bgPressed: palette.green['50'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.grayscale['900'],
        textHover: palette.grayscale['900'],
        textDisabled: palette.grayscale['300'],
        iconDefault: palette.grayscale['900'],
        iconHover: palette.grayscale['900'],
        iconDisabled: palette.grayscale['300'],
        borderDefault: palette.grayscale['50'],
        borderHover: palette.green['50'],
        borderDisabled: palette.grayscale['200']
      },
      tertiary: {
        bgDefault: palette.grayscale['50'],
        bgHover: palette.blue['700'],
        bgPressed: palette.grayscale['50'],
        bgDisabled: palette.grayscale['200'],
        textDefault: palette.blue['700'],
        textHover: palette.grayscale['50'],
        textDisabled: palette.grayscale['300'],
        iconDefault: palette.blue['700'],
        iconHover: palette.grayscale['50'],
        iconDisabled: palette.grayscale['300'],
        borderDefault: palette.grayscale['50'],
        borderHover: palette.blue['700'],
        borderDisabled: palette.grayscale['200']
      }
    },
    faq: {
      border: 'rgba(255, 255, 255, 0.5)'
    }
  },
}

  